export default "/images/48933026d558137c1a77632f6106e618.avif";